import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const GoogleRatingBadge = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/rating`)
      .then((r) => {
        if (r.data.rating) setData(r.data);
      })
      .catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.25, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="mt-8 inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/[0.04] backdrop-blur-xl px-5 py-2.5"
      data-testid="google-rating-badge"
    >
      <span className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            className={`h-4 w-4 ${i <= Math.round(data.rating) ? "fill-white text-white" : "text-slate-700"}`}
          />
        ))}
      </span>
      <span className="text-sm text-slate-300" data-testid="google-rating-text">
        {data.rating.toFixed(1)} on Google{data.count ? ` · ${data.count} reviews` : ""}
      </span>
    </motion.div>
  );
};
